<template>
  <v-layout>
    <v-flex>

      <!-- Filtri -->
      <v-flex xs12 d-flex class="accent pa-1 elevation-1 white--text">
        <v-flex xs12 sm6 md3>
          <tecnici-select :label="$t('label.tecnico')" v-model="filters.tecnico" class="input--dense" solo-inverted flat
            dark clearable />
        </v-flex>

        <v-flex xs12 sm6 md3>
          <agricoltori-select :label="$t('label.cliente')" v-model="filters.agricoltore" class="input--dense"
            solo-inverted flat dark clearable />
        </v-flex>

        <v-flex xs12 sm6 md2 class="mr-4">
          <date-picker :prefix="$t('label.da') + ':'" :locale="$i18n.locale" v-model="filters.from" :max="filters.to"
            class="input--dense date-input" solo-inverted flat dark clearable />
        </v-flex>

        <v-flex xs12 sm6 md2 class="mr-3">
          <date-picker :prefix="$t('label.a') + ':'" :locale="$i18n.locale" v-model="filters.to" :min="filters.from"
            class="input--dense date-input mr-2" solo-inverted flat dark clearable />
        </v-flex>

        <v-flex d-flex xs12 md2>
          <v-btn center dark color="rgba(255,255,255,0.16)" class="ma-0 height-36" @click="clearFilters()">
            {{ $t('prenotazioni.azioni.rimuovi_filtri') }}
          </v-btn>
        </v-flex>
      </v-flex>

      <v-flex xs12 d-flex class="accent pa-1 elevation-1 white--text">
        <v-flex xs12 sm6 md4>
          <v-text-field :prefix="$t('label.numero_attestato') + ':'" :locale="$i18n.locale"
            v-model="filters.numero_attestato" class="input--dense no-wrap" solo-inverted flat dark hide-details
            clearable />
        </v-flex>

        <v-flex xs12 sm6 md4>
          <v-text-field :prefix="$t('label.cuaa') + ':'" :locale="$i18n.locale" v-model="filters.cuaa"
            class="input--dense" solo-inverted flat dark hide-details clearable />
        </v-flex>

        <v-flex xs12 sm6 md4>
          <date-picker :prefix="$t('prenotazioni.label.scadenza') + ':'" :locale="$i18n.locale"
            v-model="filters.scadenza_report" class="input--dense date-input" solo-inverted flat dark clearable />
        </v-flex>
      </v-flex>

      <v-flex xs12 d-flex class="accent pa-1 elevation-1 white--text">
        <v-flex xs12 sm6 md4>
          <v-text-field :prefix="$t('prenotazioni.label.marca') + ':'" :locale="$i18n.locale" v-model="filters.marca"
            class="input--dense ma-0 pa-0" solo-inverted flat dark hide-details clearable />
        </v-flex>

        <v-flex xs12 sm6 md4>
          <v-text-field :prefix="$t('prenotazioni.label.modello') + ':'" :locale="$i18n.locale"
            v-model="filters.modello" class="input--dense ma-0 pa-0" solo-inverted flat dark hide-details clearable />
        </v-flex>

        <v-flex xs12 sm6 md4>
          <v-text-field :prefix="$t('prenotazioni.label.telaio') + ':'" :locale="$i18n.locale" v-model="filters.numero_serie"
            class="input--dense ma-0 pa-0" solo-inverted flat hide-details dark clearable />
        </v-flex>
      </v-flex>

      <!-- Tabella reports -->
      <data-table ref="reportTable" :headers="[
        { text: $t('label.numero_attestato'), value: 'numero', width: 10 },
        { text: $t('label.data'), value: 'data_controllo', width: 10 },
        { text: $t('label.cliente'), value: 'id_agricoltore', width: 13 },
        { text: $t('label.cuaa'), value: 'cuaa', width: 13 }, // dato mancante 
        { text: $t('prenotazioni.label.marca'), value: 'marca', width: 12 },
        { text: $t('prenotazioni.label.modello'), value: 'modello', width: 11 },
        { text: $t('prenotazioni.label.telaio'), value: 'numero_serie', width: 10 }, // dato mancante 
        { text: $t('prenotazioni.label.scadenza'), value: 'scadenza', width: 11 },
        { text: $t('label.tecnico'), value: 'id_tecnico', width: 10 }]" :width-auto="true" :items="reports" :loading="loading"
        show-header-button :rows-per-page="rowsPerPage" :total-items="totalItems" @page="onPageChanged"
        @click:item="showReportDialog">

        <v-btn slot="headerButton" @click="showGenerateDocumentationDialog"
               block round dark color="rgba(255,255,255,0.16)" class="ma-0 mr-2 height-36">
          <v-icon class="mr-2" small>save_alt</v-icon>
          <span>{{ $t('reports.label.generazione_documentazione') }}</span>
        </v-btn>

        <template slot="items" slot-scope="{ item }">
          <td>
            <v-tooltip bottom>
              <v-icon slot="activator" :color="item.compilato ? 'success' : 'error'">{{ item.compilato ? 'check_circle'
                : 'error' }}</v-icon>
              <span>{{ item.compilato ? $t('reports.messaggi.compilato') : $t('reports.messaggi.non_compilato')
              }}</span>
            </v-tooltip>
            <span class="ml-2" style="vertical-align: text-bottom">{{ item.numero }}</span>
          </td>
          <td>{{ $d($utils.date.toJs(item.data_controllo)) }}</td>
          <td>{{ item.id_agricoltore && getRagioneSocialeById(item.id_agricoltore) }}</td>
          <td>{{ item.cuaa }}</td>
          <td>{{ item.marca }}</td>
          <td>{{ item.modello }}</td>
          <td>{{ item.numero_serie }}</td>
          <td>{{ item.scadenza }}</td>
          <td colspan="2">{{ item.id_tecnico && getNomeCognomeById(item.id_tecnico) }}</td>
        </template>

      </data-table>

      <report-dialog ref="reportDialog" @success="AtReportSuccess" />
      <report-documentation-dialog ref="reportDocumentationDialog" />

    </v-flex>
  </v-layout>
</template>

<script>
import { AgricoltoriSelect, TecniciSelect, DatePicker } from '@/components/inputs'
import DataTable from '@/components/base/DataTable'
import ReportDialog from '@/components/ReportDialog'
import ReportDocumentationDialog from '@/components/ReportDocumentationDialog'

export default {
    name: 'Reports',
    components: { AgricoltoriSelect, TecniciSelect, DatePicker, DataTable, ReportDialog, ReportDocumentationDialog },
    data: () => ({
        loading: false,
        reports: [],
        rowsPerPage: 11,
        totalItems: 0,
        filters: {
            tecnico: null,
            agricoltore: null,
            from: null,
            to: null,
            numero_attestato: null,
            cuaa: null,
            scadenza_report: null,
            marca: null,
            modello: null,
            numero_serie: null
        }
    }),
    watch: {
        filters: {
            handler () {
                this.$refs.reportTable.resetPage()
                this.fetchData(1)
            },
            deep: true
        }
    },
    mounted () {
        //  Per evitare errori prima carico i dati di agricoltori e tecnici e poi carico i report
        this.loading = true
        Promise.all([
            this.$store.dispatch('loadAgricoltori'),
            this.$store.dispatch('loadTecnici')
        ]).then(() => {
            this.fetchData(1)
        }).catch(e => {
            this.$snackbar.showServerError(e)
            this.loading = false
        })
    },
    methods: {
        getRagioneSocialeById (id) {
            let agricoltore = this.$store.getters.getAgricoltoreById(id)
            return agricoltore ? agricoltore.ragione_sociale : '-'
        },
        getNomeCognomeById (id) {
            let tecnico = this.$store.getters.getTecnicoById(id)
            return tecnico ? tecnico.nome_cognome : '-'
        },
        showReportDialog (report) {
            this.$refs.reportDialog.show(report, null, true)
        },
        showGenerateDocumentationDialog () {
            this.$refs.reportDocumentationDialog.show()
        },
        clearFilters () {
            for (let key in this.filters) {
                if (this.filters.hasOwnProperty(key)) {
                    this.filters[key] = null
                }
            }
        },
        onPageChanged (page) {
            this.fetchData(page)
        },
        fetchData (page) {
            this.loading = true
            this.$api.reports.get({
                ...this.filters,
                p: page,
                n: this.rowsPerPage
            }).then(response => {
                this.loading = false
                this.reports = response.data.items || [];
                this.totalItems = response.data.n
            }).catch(e => {
                this.$snackbar.showServerError(e)
                this.loading = false
            })
        },
        AtReportSuccess () {
          this.$refs.reportTable.resetPage()
          this.fetchData(1)
        }
    }
}
</script>
<style lang="scss" scoped>
  .date-input /deep/ .v-input__control {
    color: rgba(255, 255, 255, 0.7);
  }
</style>
